import axios from '@/utils/request';

let prefix = process.env.VUE_APP_API_PREFIX_2;

// 获取角色列表
const GetRoleList = params => {
  return axios.get(prefix + '/role/GetRoleList', {
    params
  });
};

// 获取角色详情
const GetRoleRecord = params => {
  return axios.get(prefix + '/role/GetRoleRecord', {
    params
  });
};

// 创建角色
const CreateRole = data => {
  return axios.post(prefix + '/role/CreateRole', data);
};

// 修改角色
const UpdateRole = data => {
  return axios.put(prefix + '/role/UpdateRole', data);
};

// 修改角色状态
const UpdateRoleStatus = data => {
  return axios.put(prefix + '/role/UpdateRoleStatus', data);
};

// 修改角色状态
const DeleteRole = data => {
  return axios.delete(prefix + '/role/DeleteRole', data);
};

// 修改角色推送设置
const UpdatePushSetting = data => {
  return axios.put(prefix + '/role/UpdatePushSetting', data);
};

export { GetRoleList, GetRoleRecord, CreateRole, UpdateRole, UpdateRoleStatus, DeleteRole, UpdatePushSetting };
